import { SET_SIDEBAR_SCREEN, SidebarActionTypes, SidebarState } from './types';

const initialState: SidebarState = {
    screen: 'menu',
};

export default function sidebarReducer(
    state = initialState,
    action: SidebarActionTypes,
): SidebarState {
    switch (action.type) {
        case SET_SIDEBAR_SCREEN:
            return {
                ...state,
                screen: action.payload.screen,
            };
        default:
            return {
                ...state,
            };
    }
}
